import { render, staticRenderFns } from "./NewEmployees.vue?vue&type=template&id=2438685c&scoped=true"
import script from "./NewEmployees.vue?vue&type=script&lang=js"
export * from "./NewEmployees.vue?vue&type=script&lang=js"
import style0 from "./NewEmployees.vue?vue&type=style&index=0&id=2438685c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438685c",
  null
  
)

export default component.exports